// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1H2zR","row":"Node_row__21x5-","label":"Node_label__1G8Qw","footer":"Node_footer__208kb"};